<template>
  <div class="imageBox" ref="imageBox" :style="'height: ' + imageBoxHeight + 'px; max-height: ' + imageBoxMaxHeight + 'px;'">
    <transition-group name="fade">
      <div v-for="number in [currentNumber]" :key="number" class="image">
        <img :src="currentImage">
      </div>-->
    </transition-group>
  </div>
</template>

<script>
export default {
  name: 'ImageSlider',
  props: {
    images: {
      type: Array,
      default: () => { return [] }
    }
  },
  data () {
    return {
      currentNumber: 0,
      timer: null,
      imageBoxHeight: 0,
      imageBoxMaxHeight: 0
    }
  },
  created () {
    window.addEventListener('resize', this.handleResize)
    this.handleResize()
  },
  destroyed () {
    window.removeEventListener('resize', this.handleResize)
  },
  mounted () {
    this.$nextTick(() => {
      this.setContainerHeight(this.images[0])
      this.startRotation()
    })
  },
  methods: {
    handleResize () {
      this.setContainerHeight(this.images[0])
    },
    setContainerHeight (url) {
      const vm = this
      const containerWidth = this.$refs.imageBox ? this.$refs.imageBox.clientWidth : 0
      let ratio = 0
      var img = new Image()
      img.src = url
      img.addEventListener('load', function () {
        ratio = containerWidth / this.naturalWidth
        vm.imageBoxHeight = Math.round(this.naturalHeight * ratio)
        vm.imageBoxMaxHeight = this.naturalHeight
      })
    },
    startRotation () {
      this.timer = setInterval(this.next, 4000)
    },
    stopRotation () {
      clearTimeout(this.timer)
      this.timer = null
    },
    next () {
      this.currentNumber += 1
    },
    previous () {
      this.currentNumber -= 1
    }
  },
  computed: {
    currentImage () {
      return this.images[Math.abs(this.currentNumber) % this.images.length]
    }
  }
}
</script>

<style lang='scss' scoped>
.fade-enter-active,
.fade-leave-active {
  transition: all 0.8s ease;
  overflow: hidden;
  visibility: visible;
  opacity: 1;
  position: absolute;
  left: 0;
}
.fade-enter,
.fade-leave-to {
  opacity: 0;
  visibility: hidden;
}
.imageBox {
  width: 100%;
  position: relative;
  .image {
    //  position: absolute;
    //  left: 0;
    //  top: 0;
  img {
      max-width: 100%;
      height: auto;

    }
  }

}
</style>
